module.exports = __webpack_public_path__ + "static/img/circleBack.f765597b.png";